import { Alignment } from "@faire/web-api--source/indigofair/data/Alignment";
export var getCssAlignmentValue = function(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "flex-start";
    switch(key){
        case Alignment.ALIGNMENT_START:
            return "flex-start";
        case Alignment.ALIGNMENT_CENTER:
            return "center";
        case Alignment.ALIGNMENT_END:
            return "flex-end";
        default:
            return defaultValue;
    }
};
